<template>
  <svg width="8" height="24" viewBox="0 0 8 14" fill="#9FA1AA" xmlns="http://www.w3.org/2000/svg"><path d="M7.53329 11.3222L3.26737 7L7.54428 2.67778C7.82121 2.39792 7.92936 1.99002 7.828 1.60773C7.72663 1.22543 7.43116 0.926829 7.05287 0.824394C6.67459 0.721959 6.27096 0.831256 5.99404 1.11111L0.947508 6.21111C0.741658 6.41872 0.625977 6.70055 0.625977 6.99445C0.625977 7.28835 0.741658 7.57018 0.947508 7.77778L5.99404 12.8778C6.42283 13.3111 7.11549 13.3111 7.54428 12.8778C7.96446 12.4444 7.95955 11.7495 7.53329 11.3222Z" fill="#9FA1AA"></path></svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
